import React from "react";

const RecipeBadges = ({ header, badge }) => {
  return (
    <div className="Column">
      <img
        className={
          header ? "Width-1-5 marg-right-5 br-100" : "P-T-R-L-5 Width-4 Badge"
        }
        alt={badge.name}
        src={badge.image}
      />
      <p className={header ? "Hidden" : "Small-Font Justify-Center Green"}>
        {badge.name}
      </p>
    </div>
  );
};

export default RecipeBadges;
